import React, { useContext, useEffect, useState } from 'react';
import { Button, CircularProgress, Grid } from '@material-ui/core';

import { fbmApi as api } from 'api/fbm';
import { UserContext } from 'contexts/UserContext';
import { DataTable, FBMAccountPicker, Notifications } from 'shared';
import dayjs from 'utils/dayjsConfig';

const EST_TIMEZONE = 'America/New_York';

function formatIngestDateEst(ingestDate) {
    if (!ingestDate?.date) {
        return '';
    }

    const parsed = ingestDate.timezone ? dayjs.tz(ingestDate.date, ingestDate.timezone) : dayjs(ingestDate.date);

    return parsed.tz(EST_TIMEZONE).format('MM/DD/YYYY h:mm a');
}

function FBMIngestionResults() {
    const [rows, setRows] = useState([]);
    const [notification, setNotification] = useState({ text: null, level: null });
    const { fbmAccount } = useContext(UserContext);
    const [isDownloadingIngest, setIsDownloadingIngest] = useState(false);

    const handleDownloadIngestResults = async () => {
        setIsDownloadingIngest(true);
        try {
            await api.downloadIngestResults(fbmAccount.fbmAccountName);
        } catch (e) {
            setNotification({ text: 'Failed to download ingest results. Please try again.', level: 'error' });
        } finally {
            setIsDownloadingIngest(false);
        }
    };

    // Load rows
    const getRows = async () => {
        const response = await api.getBulkOrderIngestionDetails(fbmAccount.fbmAccountName);
        if (response.status === false || !response.data) {
            setNotification({ text: `No entries found ${response.msg}`, level: 'error' });
            setRows([]);
            return;
        }

        setRows(response.data.data);
    };

    useEffect(() => {
        if (fbmAccount.id) {
            getRows();
        }
    }, [fbmAccount]);

    const cols = [
        {
            accessor: 'ingestDate.date',
            Header: 'Ingest Date (EST)',
            sortType: 'datetimeString',
            Cell: ({ row }) => formatIngestDateEst(row.original.ingestDate),
        },
        { accessor: 'numberOfOrdersIngested', Header: 'Number of Orders Ingested' },
        { accessor: 'status', Header: 'Status / Result' },
        { accessor: 'user', Header: 'User' },
        { accessor: 'notes', Header: 'Notes' },
    ];

    return (
        <Grid container>
            <Notifications options={notification} />
            <Grid item xs={12}>
                <FBMAccountPicker />
            </Grid>
            {!!fbmAccount.id && (
                <>
                    <Grid item md={6} style={{ textAlign: 'left', paddingLeft: '40px' }}>
                        <h1>{fbmAccount.companyName} Bulk Order Ingestion</h1>
                    </Grid>
                    <Grid item xs={12} style={{ paddingLeft: '40px', marginBottom: '10px' }}>
                        <Button
                            variant="outlined"
                            color="secondary"
                            onClick={handleDownloadIngestResults}
                            disabled={isDownloadingIngest}
                        >
                            {isDownloadingIngest ? <CircularProgress size={18} /> : 'Download Ingest Results'}
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable columns={cols} data={rows} />
                    </Grid>
                </>
            )}
        </Grid>
    );
}

export { FBMIngestionResults };
